/**
 * Ordem das etapas do cadastro da Realização Destaque (RCP-01).
 *
 * O cadastro guarda a etapa pelo índice lógico de sempre (0 participantes, 1 informações, 2 detalhes): é o que o
 * rascunho parcial grava e o que as validações leem. A tela segue a ordem do design, com Participantes por último.
 * Manter o índice evita reinterpretar os rascunhos já salvos.
 */
export const ORDEM_DE_EXIBICAO = [1, 2, 0];

export function primeiraEtapa(): number {
  return ORDEM_DE_EXIBICAO[0];
}

export function ultimaEtapa(): number {
  return ORDEM_DE_EXIBICAO[ORDEM_DE_EXIBICAO.length - 1];
}

/** Posição da etapa na tela, a partir de 0 ("Etapa n de 3" usa `posicaoNaTela + 1`). */
export function posicaoNaTela(etapa: number): number {
  return ORDEM_DE_EXIBICAO.indexOf(etapa);
}

export function proximaEtapa(etapa: number): number | undefined {
  return ORDEM_DE_EXIBICAO[posicaoNaTela(etapa) + 1];
}

export function etapaAnterior(etapa: number): number | undefined {
  const posicao = posicaoNaTela(etapa);
  return posicao > 0 ? ORDEM_DE_EXIBICAO[posicao - 1] : undefined;
}

/**
 * Etapa em que um rascunho reabre. Participantes (ou etapa desconhecida) reabre em Informações: um rascunho antigo
 * nessa etapa nunca passou pelas Informações, e abrir direto nela deixaria "Finalizar" ao alcance sem validá-las.
 */
export function etapaAoRetomar(etapaSalva: unknown): number {
  return etapaSalva === 1 || etapaSalva === 2 ? etapaSalva : primeiraEtapa();
}
